import {
  ArrowDownCircleIcon,
  BuildingOfficeIcon,
} from "@heroicons/react/24/solid";
import React, { useRef, useState } from "react";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import useGetAllOfficesStatus from "./hooks/useGetAllOfficesStatus";
import { CSVLink } from "react-csv";
import { toast } from "../../../../components/toastNotification";
import DownloadButton from "../../../../components/DownloadButton";
import { CarrierAgreementMgmtTabs } from "../../carrierAgreementTabs";
import { useRecoilState, useRecoilValue } from "recoil";
import { mainSelectedTab } from "../../atoms";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import useGetAllSalesforce from "./hooks/useGetAllSalesforce";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { accountAtom } from "../../../Login/atoms/AccountAtom";

interface IAllOfficesStatus {
  legalEntity: string;
  officeLegalEntityId: number;
  glEntityName: string;
  generalLedgerNumber: number;
  storeNumber: number;
  officeCode: string;
  officeName: string;
  officeId: number;
  brand: string;
  brandId: number;
  bmoname: string;
  bmoId: number;
  officeStatus: string;
  officeOpenedDate: string;
  officeClosedDate: string;
  darkReasonEffectiveDate: string;
  relocationDate: string;
  officeStatusDetails: string;
  officeRelated: string;
  acquisitionId: number;
  address: string;
  city: string;
  zipCode: string;
  state: string;
  phone: string;
  fullAddress: string;
  channelC: string;
  salesType: string;
  officeType: string;
  districtCode: string;
  districtName: string;
  districtManager: string;
  areaCode: string;
  areaName: string;
  salesVP: string;
}

export const SalesforceAllOffices: React.FC<IAllOfficesStatus> = () => {
  const [exportData, setExportData] = useState([]);
  const { data: allSalesforce, isLoading: allSalesforceLoading } =
    useGetAllSalesforce();

  const tableRef = useRef<any>([]);

  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const user = useRecoilValue(accountAtom);

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [month, day, year].join("/");
  }

  //For downloading table data
  const mapDataToExport = (data) => {
    setExportData(
      data?.map((ofc: IAllOfficesStatus) => {
        return {
          "Legal Entity": ofc.legalEntity,
          "GL Entity":
            (ofc.generalLedgerNumber ? ofc.generalLedgerNumber + "-" : "") +
            (ofc.glEntityName ? ofc.glEntityName : ""),
          "Corporate Office #": ofc.storeNumber,
          "Office Code": ofc.officeCode,
          // "Local Office #": ofc.storeNumber,
          "Office Name": ofc.officeName,
          Brand: ofc.brand,
          BMO: ofc.bmoname,
          "Office Status": ofc.officeStatus,
          "Office Opened Date": ofc.officeOpenedDate
            ? formatDate(ofc.officeOpenedDate)
            : "",
          "Office Closed Date": ofc.officeClosedDate
            ? formatDate(ofc.officeClosedDate)
            : "",
          "Dark Status Effective Date": ofc.darkReasonEffectiveDate
            ? formatDate(ofc.darkReasonEffectiveDate)
            : "",
          "Relocation Date": ofc.relocationDate
            ? formatDate(ofc.relocationDate)
            : "",
          "Office Status Details": ofc.officeStatusDetails,
          "Office Related to Office Status Detail": ofc.officeRelated,
          "Acquisition Id": ofc.acquisitionId,
          "Physical Street": ofc.address,
          "Physical City": ofc.city,
          "Physical Zip/Postal Code": ofc.zipCode,
          "Physical State/Province": ofc.state,
          Phone: ofc.phone,
          Channel: ofc.channelC,
          "Sales Type": ofc.salesType,
          Type: ofc.officeType,
          "Office District": ofc.districtCode,
          "Office District Manager": ofc.districtManager,
          "Office Area": ofc.areaCode,
          "Office Sales VP": ofc.salesVP,
        };
      })
    );
  };

  const exportdata = tableRef.current.dataManager?.searchedData?.map(
    (ofc: IAllOfficesStatus) => {
      return {
        "Legal Entity": ofc.legalEntity,
        "GL Entity":
          (ofc.generalLedgerNumber ? ofc.generalLedgerNumber + "-" : "") +
          (ofc.glEntityName ? ofc.glEntityName : ""),
        "Corporate Office #": ofc.storeNumber,
        "Office Code": ofc.officeCode,
        // "Local Office #": ofc.storeNumber,
        "Office Name": ofc.officeName,
        Brand: ofc.brand,
        BMO: ofc.bmoname,
        "Office Status": ofc.officeStatus,
        "Office Opened Date": ofc.officeOpenedDate
          ? formatDate(ofc.officeOpenedDate)
          : "",
        "Office Closed Date": ofc.officeClosedDate
          ? formatDate(ofc.officeClosedDate)
          : "",
        "Dark Status Effective Date": ofc.darkReasonEffectiveDate
          ? formatDate(ofc.darkReasonEffectiveDate)
          : "",
        "Relocation Date": ofc.relocationDate
          ? formatDate(ofc.relocationDate)
          : "",
        "Office Status Details": ofc.officeStatusDetails,
        "Office Related to Office Status Detail": ofc.officeRelated,
        "Acquisition Id": ofc.acquisitionId,
        "Physical Street": ofc.address,
        "Physical City": ofc.city,
        "Physical Zip/Postal Code": ofc.zipCode,
        "Physical State/Province": ofc.state,
        Phone: ofc.phone,
        Channel: ofc.channelC,
        "Sales Type": ofc.salesType,
        Type: ofc.officeType,
        "Office District": ofc.districtCode,
        "Office District Manager": ofc.districtManager,
        "Office Area": ofc.areaCode,
        "Office Sales VP": ofc.salesVP,
      };
    }
  );
  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
  const csvReport = {
    filename: "Salesforce-All_" + dateTimeToday + ".csv",
    data: exportData,
  };
  //

  const officeColumns = [
    { title: "Legal Entity", field: "legalEntity" },
    {
      title: "GL Entity",
      field: "glEntityName",
      render: (rowData) => {
        return (
          <div>
            {rowData.generalLedgerNumber && rowData.glEntityName
              ? rowData.generalLedgerNumber + "-" + rowData.glEntityName
              : ""}
          </div>
        );
      },
    },
    { title: "Corporate Office #", field: "storeNumber" },
    { title: "Office Code", field: "officeCode" },
    // { title: "Local Office #", field: "storeNumber" },
    {
      title: "Office Name",
      field: "officeName",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/officesettings/officesetting";
              history.push({
                pathname: url,
                state: {
                  pathname: url,
                  officeCode: rowData?.officeCode,
                  action: "SalesforceAll",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...OfficeTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
            }}
          >
            <span className="text-quinary  font-bold underline text-sm ">
              {rowData.officeName}
            </span>
          </div>
        );
      },
    },
    { title: "Brand", field: "brand" },
    { title: "BMO", field: "bmoName" },
    {
      title: "Office Status",
      field: "officeStatus",
    },
    {
      title: "Office Opened Date",
      field: "officeOpenedDate",
      render: (rowData) => {
        return (
          <div>
            {rowData.officeOpenedDate
              ? formatDate(rowData.officeOpenedDate)
              : ""}
          </div>
        );
      },
    },
    {
      title: "Office Closed Date",
      field: "officeClosedDate",
      render: (rowData) => {
        return (
          <div>
            {rowData.officeClosedDate
              ? formatDate(rowData.officeClosedDate)
              : ""}
          </div>
        );
      },
    },
    {
      title: "Dark Status Effective Date",
      field: "darkReasonEffectiveDate",
      render: (rowData) => {
        return (
          <div>
            {rowData.darkReasonEffectiveDate
              ? formatDate(rowData.darkReasonEffectiveDate)
              : ""}
          </div>
        );
      },
    },
    {
      title: "Relocation Date",
      field: "relocationDate",
      render: (rowData) => {
        return (
          <div>
            {rowData.relocationDate ? formatDate(rowData.relocationDate) : ""}
          </div>
        );
      },
    },
    { title: "Office Status Details", field: "officeStatusDetails" },
    { title: "Office Related to Office Status Detail", field: "officeRelated" },
    {
      title: "Acquisition Id",
      field: "acquisitionId",
    },
    { title: "Physical Street", field: "address" },
    { title: "Physical City", field: "city" },
    { title: "Physical Zip/Postal Code", field: "zipCode" },
    { title: "Physical State/Province", field: "state" },
    { title: "Phone", field: "phone" },
    { title: "Channel", field: "channelC" },
    { title: "Sales Type", field: "salesType" },
    { title: "Type", field: "officeType" },
    { title: "Office District", field: "districtCode" },
    { title: "Office District Manager", field: "districtManager" },
    { title: "Office Area", field: "areaCode" },
    { title: "Office Sales VP", field: "salesVP" },
    // { title: "Office Relocation", field: "officeRelated" },
  ];

  return (
    <div className="text-xs items-center">
      <div className="">
        <div className="mx-4 mt-4 overflow-x-auto">
          <div className="flex mb-2 gap-2 items-center">
            <div>
              <BuildingOfficeIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading tight">
              <div className="text-gray-500 text-md font-medium">
                Report: Accounts
              </div>
              <div className="flex items-center font-bold text-lg text-primary">
                Salesforce-ALL Report
              </div>
            </div>
          </div>
          <div className="mt-2" />
          <div className="flex justify-between mb-2 mr-2">
            <div className="flex items-center gap-1">
              <span className="text-gray-500 text-sm">Total Records: </span>
              <span className="text-primary text-base font-semibold">
                {
                  allSalesforce?.filter((x) =>
                    user?.isFranchise && user?.isNonFranchise
                      ? true
                      : user?.isFranchise
                      ? x.officeType?.toLowerCase() === "franchise"
                      : x.officeType?.toLowerCase() !== "franchise"
                  ).length
                }
              </span>
            </div>
            <CSVLink className="" {...csvReport}>
              <DownloadButton
                buttonValue="Download File"
                onClick={() =>
                  mapDataToExport(tableRef.current.dataManager.searchedData)
                }
                className={undefined}
                disabled={undefined}
              />
            </CSVLink>
          </div>
        </div>
        <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
          <MaterialTableTS
            data={allSalesforce?.filter((x) =>
              user?.isFranchise && user?.isNonFranchise
                ? true
                : user?.isFranchise
                ? x.officeType?.toLowerCase() === "franchise"
                : x.officeType?.toLowerCase() !== "franchise"
            )}
            isLoading={allSalesforceLoading}
            columns={officeColumns}
            showTitle={false}
            showToolbar={true}
            toolbarSearch={true}
            searchFieldAlignment="left"
            tableRef={tableRef}
          />
        </div>
      </div>
    </div>
  );
};
